import { Confirm } from '@coop/components';

interface EditOrderExpiredDialogProps {
    showDialog: boolean;
    handleConfirm: () => void;
    close: () => void;
}

const EditOrderExpiredDialog = ({
    handleConfirm,
    showDialog,
    close,
}: EditOrderExpiredDialogProps) => {
    return (
        <Confirm
            show={showDialog}
            heading="Tiden för att göra ändringar gick ut"
            // eslint-disable-next-line react/no-unstable-nested-components
            message={
                <span>
                    Tiden löpte ut innan du hann spara dina ändringar och din ordinarie beställning
                    har nu skickats vidare för packning. Ring kundservice på{' '}
                    <a href="tel:0771171717" className="u-textUnderline">
                        0771–171717
                    </a>{' '}
                    om du har några frågor.
                </span>
            }
            confirmButtonText="Se min beställning"
            onConfirm={handleConfirm}
            close={close}
        />
    );
};

export default EditOrderExpiredDialog;
